import React from 'react';

const COLORS = [
  ['#396BE9', 'Azul'], ['#62BF92', 'Verde'], ['#FF5757', 'Rojo'],
  ['#EC407A', 'Rosa'], ['#F59E0B', 'Naranja'], ['#8B5CF6', 'Violeta'],
  ['#06B6D4', 'Turquesa'], ['#9C27B0', 'Morado'],
];

const EXTRA_COLORS = [
  ['#1E3A8A', 'Azul marino'], ['#38BDF8', 'Celeste'], ['#14B8A6', 'Verde agua'],
  ['#84CC16', 'Lima'], ['#FACC15', 'Amarillo'], ['#F97316', 'Mandarina'],
  ['#A16207', 'Café'], ['#64748B', 'Gris azulado'],
];

export default function ColorPalette({ value, onChange, disabled = false, centered = false }) {
  return <div role="group" aria-label="Color" style={{ display: 'flex', flexWrap: 'wrap', gap: centered ? 5 : 6, justifyContent: centered ? 'center' : 'space-between', padding: '6px 0' }}>
    {(centered ? [...COLORS, ...EXTRA_COLORS] : COLORS).map(([color, name]) => <button key={color} type="button" aria-label={name} aria-pressed={value?.toUpperCase() === color} disabled={disabled}
      onClick={() => onChange(color)} style={{
        width: centered ? 24 : 26, height: centered ? 24 : 26, minHeight: centered ? 24 : 26, padding: 0, flexShrink: 0, borderRadius: '50%', background: color,
        border: value?.toUpperCase() === color ? '2px solid #396BE9' : '2px solid #FFFFFF',
        boxShadow: value?.toUpperCase() === color ? '0 0 0 2px #FFFFFF, 0 0 0 4px rgba(57,107,233,.55), 0 0 12px 4px rgba(57,107,233,.35)' : '0 2px 4px rgba(0,0,0,0.15)', cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease', transform: value?.toUpperCase() === color ? 'scale(1.05)' : 'scale(1)',
      }} />)}
  </div>;
}
